import "./SpeedAndData.scss";

import clsx from "clsx";
import { useTranslation } from "react-i18next";
import { FCWithClassName } from "types";

import { Signal, Speed } from "@/assets/icons/ds";

interface SpeedAndDataProps {
  speed: string;
}

export const SpeedAndData: FCWithClassName<SpeedAndDataProps> = ({
  className,
  speed,
}) => {
  const { t } = useTranslation();

  if (!speed) {
    return null;
  }

  return (
    <div className={clsx(className, "device-info")}>
      <div className="icon-row">
        <Speed
          className="size-6 shrink-0"
          role="img"
          aria-hidden={false}
          aria-label={t("Icons.speed")}
        />
        <span>{speed}</span>
      </div>

      <div className="icon-row">
        <Signal
          className="size-6 shrink-0"
          role="img"
          aria-hidden={false}
          aria-label={t("Icons.connection")}
        />
        <span>{t("Common.tariff.unlimitedLowercase")}</span>
      </div>
    </div>
  );
};
